<template>
    <b-list-group>
        <b-list-group-item v-for="keyResult in keyResults" :key="keyResult.id" class="p-2">
            <slot :key-result="keyResult" />
        </b-list-group-item>
    </b-list-group>
</template>

<script>
export default {
    name: 'KeyResultList',
    props: {
        keyResults: {
            type: Array,
            required: true,
        },
    },
}
</script>
